<template>
  <div id="app" name="app">
    <el-container class="container">
      <!-- 顶部导航栏 -->
      <div class="topbar">
        <div class="nav">
          <ul>
            <li v-if="!this.$store.getters.getUser">
              <el-button type="text" @click="login">登录</el-button>
            </li>
            <li v-else style="user-select: none">
              欢迎
              <el-popover placement="top" width="180" v-model="visible">
                <p>确定退出登录吗？</p>
                <div style="text-align: center; margin: 2em 0 0">
                  <el-button size="mini" type="text" @click="visible = false"
                    >取消</el-button
                  >
                  <el-button type="primary" size="mini" @click="logout"
                    >确定</el-button
                  >
                </div>
                <el-button type="text" slot="reference">{{
                  this.$store.getters.getUser.name
                }}</el-button>
              </el-popover>
            </li>
          </ul>
        </div>
      </div>
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 -->
      <el-header>
        <el-menu class="el-menu-demo"> </el-menu>
      </el-header>
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
      <MyLogin></MyLogin>
      <el-timeline style="margin-left: 20px">
        <el-timeline-item placement="top">
          <template slot="dot">
            <div
              class="
                el-timeline-item__node
                el-timeline-item__node--normal
                el-timeline-item__node--
              "
            ></div>
            <div class="el-timeline-item__wrapper">
              <div
                class="el-timeline-item__timestamp"
                style="user-select: none"
              >
                生产线
                <span style="margin-left: 100px">状态：已连接</span>
              </div>
            </div>
          </template>
        </el-timeline-item></el-timeline
      >
      <!-- 一号卡片 -->
      <!-- {{lineList}} -->
      <el-card class="card bigcard">
        <el-row :gutter="12" v-model="lineValue" @change="changeLineValue">
          <el-col
            style=""
            v-for="line in lineList"
            :key="line.proLineName"
            :span="24 / lineList.length"
          >
            <el-card style="text-align: center" shadow="hover">
              {{ line.proLineName }}

            </el-card>

            <el-card id="list" style="text-align: center；" shadow="hover">
              <el-main style="overflow: hidden; padding: 0">
                <el-row :gutter="10" v-for="index of 6" :key="index" :span="1">
                  <el-col :span="24">
                    <el-card
                      class="green"
                      v-if="
                        JSON.stringify(productionLineWaitingList) != '{}' &&
                        productionLineWaitingList[line.proLineName][
                          index - 1
                        ] != null &&
                        index == 1 
                      "
                      >{{
                        productionLineWaitingList[line.proLineName][index - 1]
                          .cph
                      }}
                    </el-card>

                    <el-card
                      class="red"
                      v-else-if="
                        JSON.stringify(productionLineWaitingList) != '{}' &&
                        productionLineWaitingList[line.proLineName][
                          index - 1
                        ] != null
                      "
                      >{{
                        productionLineWaitingList[line.proLineName][index - 1]
                          .cph
                      }}</el-card
                    >
                    <el-card class="grey" v-else>停</el-card>
                  </el-col>
                </el-row>
              </el-main>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
      <el-row :gutter="10">
        <el-col :span="24"></el-col>
      </el-row>
      <!-- 二号卡片 -->

      <el-card class="card bigcard" style="">
        <el-row :gutter="10">
          <el-col :span="24">
            <div style="margin-top: 1em; user-select: none">
              站内车辆
              <span style="margin-left: 1em">{{ waitCar.length }}台</span>
            </div>
          </el-col>
        </el-row>
        <el-row class="cardrow" style="">
          <el-col class="cardcol" style="">
            <el-row class="cardcolrow" style="">
              <el-card
                class="orange"
                style="float: left"
                v-for="(car, i) in waitCar"
                :key="car.cph"
              >
                {{ car.cph }}
                <div class="avatarnum" style="">{{ i + 1 }}</div>
              </el-card>
            </el-row>
          </el-col>
        </el-row>
      </el-card>

      <el-row :gutter="10">
        <el-col :span="24"></el-col>
      </el-row>
      <!-- 三号卡片 -->
      <el-card class="card bigcard">
        <el-row :gutter="10">
          <el-col :span="24">
            <div style="margin-top: 1em; user-select: none">
              执行任务
              <span style="margin-left: 1em">{{ workCarList.length }}台</span>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import "lib-flexible/flexible";

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path;
  },
  data() {
    return {
      visible: false, // 是否退出登录
      lineValue: "",
      lineList: [],
      workCarList: [],
      waitCar: [],
      carByLineName: {},
      productionLineWaitingList: {},
      timer: null,
    };
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem("user")) {
      // 如果已经登录，设置vuex登录状态
      this.setUser(JSON.parse(localStorage.getItem("user")));
    }
  },
  components: {
    //CrosswiseScroll,
  },
  computed: {
    ...mapGetters(["getUser", "getNum"]),
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function (val) {
      if (val === "") {
        // 用户没有登录
        // this.setShoppingCart([]);
      } else {
        // 用户已经登录,获取该用户的购物车信息
        this.getCarInfo();
        let _this = this;
        this.timer = setInterval(_this.getCarInfo, 10000); //showEedit
      }
    },
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin", "setShoppingCart"]),
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    whichCarIsHere(productLineName, sortNo, carList) {
      let car = carList.filter(
        (value) =>
          (value.state == "正在生产" || value.sortNo == sortNo) &&
          value.proLineName == productLineName
      );
      if (car.length > 0) return car[0];
      else return null;
    },
    changeLineValue() {
      this.getCarInfo();
    },
    getCarInfo() {
      this.$axios
        // .get("/api/car",{
        //   headers:{
        //     'Access-Control-Allow-Origin':'http://localhost:7506',
        //     'Access-Control-Allow-Credentials':true
        //   }
        // })
        .get("/api/car")
        .then((res) => {
          if (res.data.status === 200) {
            if (
              res.data.data.waitCarList &&
              res.data.data.waitCarList.length > 0
            ) {
              this.waitCar = res.data.data.waitCarList;
            } else {
              this.waitCar = [];
            }
            if (
              res.data.data.proLineList &&
              res.data.data.proLineList.length > 0
            ) {
              this.lineList = res.data.data.proLineList;
              this.lineList.forEach((value) => {
                this.carByLineName[value.proLineName] = {
                  workCar: null,
                  waitCarFirst: null,
                };
              });
              if (!this.lineValue) {
                this.lineValue = res.data.data.proLineList[0].proLineName;
              }
            } else {
              this.lineList = [];
            }
            if (
              res.data.data.productOrderList &&
              res.data.data.productOrderList.length > 0 &&
              res.data.data.proLineList &&
              res.data.data.proLineList.length > 0
            ) {
              this.workCarList = res.data.data.productOrderList;
              this.lineList = res.data.data.proLineList;

              // console.log(this.workCarList[carindex]);
              for (
                let productIndex = 0;
                productIndex < this.lineList.length;
                productIndex++
              ) {
                this.productionLineWaitingList[
                  this.lineList[productIndex].proLineName
                ] = new Array();

                let proWaitCars=[];

                for(let car in this.workCarList){
                  let a=this.workCarList[car];


                  if(a.proLineName==this.lineList[productIndex].proLineName){
                  proWaitCars.push(a);

                  }

                }
                // console.log(proWaitCars);

                proWaitCars.sort(function (a, b) {
                  return a.sortNo - b.sortNo;
                });
                this.productionLineWaitingList[
                  this.lineList[productIndex].proLineName
                ] = proWaitCars;

                // for (let index = 0; index < 6; index++) {
                //   // car = this.workCarList.filter((value) => {
                //   //   this.lineList.forEach(element => {
                //   //     (value.state == '正在生产' || value.state == index) &&
                //   //     value.proLineName == element.proLineName;
                //   //     console.log(element.proLineName+'    '+value.proLineName+'     '+value.state);
                //   //   });
                //   // });
                //   // console.log(car);
                //   var car = this.whichCarIsHere(
                //     this.lineList[productIndex].proLineName,
                //     index,
                //     this.workCarList
                //   );

                //   if (car != null) {
                //     this.productionLineWaitingList[
                //       this.lineList[productIndex].proLineName
                //     ].push(car);
                //   }
                //   // else {
                //   //   this.productionLineWaitingList[
                //   //     this.lineList[productIndex].proLineName
                //   //   ].push(null);
                //   // }
                // }
              }

              // console.log(this.productionLineWaitingList);

              this.workCarList = res.data.data.productOrderList;
              let workCar1 = this.workCarList.filter(
                (value) =>
                  value.state == "正在生产" &&
                  this.lineValue == value.proLineName
              );
              if (workCar1 && workCar1.length > 0) {
                this.carByLineName[workCar1[0].proLineName].workCar =
                  workCar1[0];
              } else {
                // this.carByLineName[workCar1[0].proLineName].workCar = null
              }
              let waitCarInfoList = this.workCarList.filter(
                (value) =>
                  value.state != "正在生产" &&
                  this.lineValue == value.proLineName
                  );
                  if (waitCarInfoList.length > 0) {
                  waitCarInfoList = waitCarInfoList.sort((a, b) => {
                  return a.sortNo - b.sortNo;
                  });
                  this.carByLineName[
                  waitCarInfoList[0].proLineName
                  ].waitCarFirst = waitCarInfoList[0];
                  } else {
                  // this.carByLineName[waitCarInfoList[0].proLineName].waitCarFirst = null
                  }
                  } else {
                  this.workCarList = [];
                  this.carByLineName = {};
                  // this.waitCarFirst = null;
                  // this.workCar = null;
                  }

                  ///////////////////////////////////////////////
                  // console.log(this.productionLineWaitingList);
                  ///////////////////////////////////////////////

                  // console.log(this.workCarList); //showe edit
                  // console.log(this.carByLineName);
                  } else {
                  // 提示失败信息
                  this.notifyError(res.data.msg);
                  }
                  })
                  .catch((err) => {
                  return Promise.reject(err);
                  });
                  },

                  // 退出登录
                  logout() {
                  this.visible = false;
                  // 清空本地登录信息
                  localStorage.setItem("user", "");
                  // 清空vuex登录信息
                  this.setUser("");
                  this.lineValue = null;
                  this.lineList = [];
                  this.workCarList = [];
                  this.waitCar = [];
                  this.carByLineName = {};
                  this.productionLineWaitingList = {};
                  clearInterval(this.timer);
                  this.timer = null;
                  this.notifySucceed("成功退出登录");
                  },
                  mounted () {
                  window.addEventListener( 'beforeunload', this.logout() );//退出浏览器或关闭窗口自动重置登陆状态
                  },
                  },
                  };
                </script>

<style>
@import "App.css";

/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}
#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 20px 0;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 1225px;
  margin: 0 auto;
}
.el-header {
  height: 0 !important;
}
/* 顶栏容器CSS END */
</style>
